import { c as _c } from "react/compiler-runtime";
import { Box, Button, Center, SimpleGrid, Spinner } from '@chakra-ui/react';
import { MemberSearchFilters, MemberSearchPagination } from '@src/components/sco/Members/MemberSearchResults';
import { MemberCard } from '@src/components/sco/Members/MembersCardGrid/MemberCard';
import { PaywalledAction } from '@src/components/sco/PaywalledAction';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { ScoUser, ScoUserCollection } from '@src/graphql-types';
import { QueryStateSet } from '@src/hooks/useQueryStateSet';
import React from 'react';
type MembersCardGridProps = {
  filters?: QueryStateSet<MemberSearchFilters>;
  loading?: boolean;
  members?: ScoUser[];
  membersCollection?: ScoUserCollection;
  onLoadMore?: () => void;
  pagination?: QueryStateSet<MemberSearchPagination>;
};
export const MembersCardGrid = props => {
  const $ = _c(17);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] !== props.members || $[1] !== props.membersCollection?.items) {
    t0 = props.members || props.membersCollection?.items || [];
    $[0] = props.members;
    $[1] = props.membersCollection?.items;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const members = t0;
  let t1;
  if ($[3] !== getBreakpointValue) {
    t1 = getBreakpointValue([1, 1, 2, 3, 4]);
    $[3] = getBreakpointValue;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== members) {
    t2 = members.map(_temp);
    $[5] = members;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <SimpleGrid columns={t1} gap={4}>{t2}</SimpleGrid>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== props.loading || $[11] !== props.membersCollection?.pagination?.hasNextPage || $[12] !== props.onLoadMore) {
    t4 = props.onLoadMore && props.membersCollection?.pagination?.hasNextPage && <Box paddingY="1em"><PaywalledAction contentPermission="canAccessFGMemberDirectory" intent="member-directory" title="Become a Community Member to view the full Founder Directory." variant="boxed"><Center><Button disabled={props.loading} variant="outline" onClick={props.onLoadMore}>{props.loading ? <Spinner /> : "Load More"}</Button></Center></PaywalledAction></Box>;
    $[10] = props.loading;
    $[11] = props.membersCollection?.pagination?.hasNextPage;
    $[12] = props.onLoadMore;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
MembersCardGrid.fragments = {
  ScoUser: MemberCard.fragments.ScoUser
};
function _temp(member) {
  return <MemberCard key={member.id} member={member} />;
}